export default __webpack_public_path__ + "static/media/Fiix.16ed5c10.png";